import UncontrolledInputSelect from "../../inputs/UncontrolledInputSelect";
import { stringifyFilterRelation } from "./utils";
import { ProcessFilterZod } from "@avenueops/shared-types";
import { DropdownSelect } from "@avenueops/web-components";

interface Props {
  filter: ProcessFilterZod;
  setFilter: (_: ProcessFilterZod) => void;
  relations: string[];
}

export default function ProcessTableFilterRelationSelect({ relations, filter, setFilter }: Props) {
  if (filter.type !== "TIME_TO_RESOLUTION") {
    throw Error("Invalid filter supplied");
  }

  return (
    <div className="w-fit">
      <DropdownSelect
        name="timeToResolutionRelationSelect"
        options={relations.map((relation) => ({
          value: relation as unknown as string,
          label: stringifyFilterRelation(relation),
        }))}
        selectedValue={filter.relation}
        disableUnselect
        size="MEDIUM"
        onChange={(relation: string | undefined) => setFilter({ ...filter, relation } as ProcessFilterZod)}
      />
    </div>
  );
}
